module.exports = __webpack_public_path__ + "img/Armanto-Witjaksono-nologo.2ab787ce.png";